import get from 'lodash/get';

import api from '../lib/api';

export const FETCH_ALL_WRANGLERS = 'FETCH_ALL_WRANGLERS';
export const FETCH_MARKET_WRANGLERS = 'FETCH_MARKET_WRANGLERS';
export const WRANGLERS_LOADING = 'WRANGLERS_LOADING';
export const SET_ACTIVE_WRANGLER = 'SET_ACTIVE_WRANGLER';

export default {
  createUserIOS(emails) {
    return () => api.addToAppCenterIOS(emails);
  },
  createUserAndroid(emails) {
    return () => api.addToAppCenterAndroid(emails);
  },
  resendUserIOS(emails) {
    return () => api.resendEmailAppCenterIOS(emails);
  },
  resendUserAndroid(emails) {
    return () => api.resendEmailAppCenterAndroid(emails);
  },
  deleteUserIOS(emails) {
    return () => api.deleteEmailAppCenterIOS(emails);
  },
  deleteUserAndroid(emails) {
    return () => api.deleteEmailAppCenterAndroid(emails);
  },
  fetchWranglers(query) {
    return (dispatch) => {
      dispatch({ type: WRANGLERS_LOADING, payload: true });

      return api.getWranglers(query)
        .then((wranglers) => {
          if (get(query, 'market_id')) {
            dispatch({ type: FETCH_MARKET_WRANGLERS, payload: wranglers });
          } else {
            dispatch({ type: FETCH_ALL_WRANGLERS, payload: wranglers });
          }
        })
        .then(() => {
          dispatch({ type: WRANGLERS_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: WRANGLERS_LOADING, payload: false });
        });
    };
  },
  createWrangler(wrangler) {
    return () => api.createWrangler(wrangler);
  },
  updateWrangler(wrangler, wranglerId) {
    return () => api.updateWrangler(wrangler, wranglerId);
  },
  setActiveWrangler(wrangler) {
    return async (dispatch) => {
      await api.setActiveWrangler(wrangler._id);
      dispatch({ type: SET_ACTIVE_WRANGLER, payload: wrangler });
    };
  },
};
